import React from 'react';

const Loading = () => (
    <div data-component="Loading" className="loading-wrapper">
        Chargement en cours
    </div>
);

export default Loading;
